import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { LegalMentionService } from '../shared/services/legal-mention.service';

@Component({
  selector: 'app-legal-mention',
  standalone: true,
  imports: [],
  templateUrl: './legal-mention.component.html',
  styleUrl: './legal-mention.component.scss',
})
export class LegalMentionComponent implements OnDestroy, OnInit {
  private readonly _destroying$ = new Subject<void>();

  sanitizedContent: string = '';

  constructor(private readonly legalMentionService: LegalMentionService) {}

  ngOnDestroy() {
    this._destroying$.next();
    this._destroying$.complete();
  }

  ngOnInit() {
    this.getLegalMentions();
  }

  private getLegalMentions(): void {
    this.legalMentionService.getLegalMentions().subscribe(content => {
      this.sanitizedContent = content;
    });
  }
}
